import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TicketsService } from 'src/app/_services/tickets.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProductsService } from 'src/app/_services/products.service';
import { ProblemsService } from 'src/app/_services/problems.service';
import { ImpactsService } from 'src/app/_services/impacts.service';
import { User } from 'src/app/_models';
import { NotificationService } from 'src/app/_services/notification.service';
import { UploadService } from 'src/app/_services/upload.service';
import { saveAs } from 'file-saver';
import { Location } from '@angular/common';

@Component({
  selector: 'app-ticket-detail',
  templateUrl: './ticket-detail.component.html',
  styleUrls: ['./ticket-detail.component.css'],
})
export class TicketDetailComponent implements OnInit {
  ticketId: string;

  products: any[];
  problems: any[];
  impacts: any[];
  statusList: any[];
  attachedFiles: any[];
  loading = false;
  error = '';
  product = '';
  isassigningtome: boolean = false;
  submitted: boolean = false;
  startDateString: string;

  cUser: User = JSON.parse(localStorage.getItem('currentUser'));
  Name: string = this.cUser?.name;
  Role: string = this.cUser?.roles;
  isAdminUser: boolean = false;
  isCSPUser: boolean = false;
  isCustomer: boolean = false;

  ticket = {
    TicketID: '',
    ProductId: '',
    ProblemId: '',
    ImpactID: '',
    TicketStatusID: undefined,
    Contact: '',
    CC_EmailId: '',
    Description: '',
    Assinged: 1,
    CreatedBy: '',
    ModifiedBy: '',
    UserId: '',
    LastReply: '',
    Reply: '',
    StartDateString: '',
    AssignId: '',
    AssingedTo: '',
    UserName: '',
    IsAssignedToMe: false,
  };

  constructor(
    private route: ActivatedRoute,
    private productservice: ProductsService,
    private problemservice: ProblemsService,
    private impactservice: ImpactsService,
    private formBuilder: FormBuilder,
    private uploadService: UploadService,
    private ticketsService: TicketsService,
    private notifyService: NotificationService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.cUser = JSON.parse(localStorage.getItem('currentUser'));
    this.isCSPUser = this.cUser.roles == 'CSP' ? true : false;
    this.isAdminUser = this.cUser.roles == 'Admin' ? true : false;
    this.isCustomer = this.cUser.roles == 'Customer' ? true : false;
    this.ticket.UserName = this.cUser.name;

    this.getProductList();

    this.getTicketStatusList();

    this.route.paramMap.subscribe((param) => {
      this.ticketId = param.get('ticketID');
      this.loadTicketdetails(this.ticketId);
    });
  }

  //   // convenience getter for easy access to form fields
  // get f() { return this.ticketForm.controls; }

  getProject(projectId) {
    let project = this.products.filter(function (el) {
      return el.productID == projectId;
    });
    return project;
  }

  loadTicketdetails(tickeId) {
    this.ticketsService.getTicket(tickeId).subscribe(
      (res) => {
        if (res != null) {
          this.ticket.TicketID = this.ticketId;
          this.ticket.ProductId = res.productId;

          this.getProblems(res.productId);

          this.ticket.ProblemId = res.problemId;
          this.ticket.StartDateString = res.startDateString;
          this.ticket.CC_EmailId = res.cC_EmailId;
          this.ticket.Contact = res.contact;
          this.ticket.Description = res.description;
          this.ticket.TicketStatusID = res.ticketStatusID;
          this.ticket.LastReply = res.lastReply;
          this.ticket.AssingedTo = res.assingedTo;
          this.ticket.IsAssignedToMe = res.isAssignedToMe;

          this.getAttachedFiles(this.ticketId);

          setTimeout(() => {
            this.ticket.ImpactID = res.impactID;
          }, 2000);
        }
      },
      (err) => {
        //this.router.navigate(['/']);
      }
    );
  }

  getProductList() {
    this.productservice.getProductList().subscribe(
      (res) => {
        this.products = <any[]>res;
      },
      (error) => {
        this.error = error;
        this.loading = false;
      }
    );
  }

  getTicketStatusList() {
    this.ticketsService.getTicketStatusList().subscribe(
      (res) => {
        this.statusList = <any[]>res;
      },
      (error) => {
        this.error = error;
        this.loading = false;
      }
    );
  }

  onProductSelection() {
    this.getProblems(this.ticket.ProductId);
  }

  getProblems(productId: string) {
    this.problemservice.getProblemsByProductId(productId).subscribe(
      (res) => {
        this.problems = <any[]>res;
        this.getImpacts(productId, this.ticket.ProblemId);
      },
      (error) => {
        this.error = error;
        this.loading = false;
      }
    );
  }

  onProblemSelection() {
    this.getImpacts(this.ticket.ProductId, this.ticket.ProblemId);
  }

  getImpacts(selectedProductId: string, selectedProblemId: string) {
    this.impactservice
      .getImpactList(selectedProductId, selectedProblemId)
      .subscribe(
        (res) => {
          this.impacts = <any[]>res;
        },
        (error) => {
          this.error = error;
          this.loading = false;
        }
      );
  }

  onSubmit(valid: boolean) {
    this.submitted = true;

    // stop here if form is invalid
    if (!valid) {
      return;
    }

    this.loading = true;

    this.ticket.UserId = this.cUser.userId;
    this.ticket.CreatedBy = this.cUser.userId;
    this.ticket.UserName = this.cUser.name;

    this.ticketsService.updateTicket(this.ticket).subscribe(
      (data) => {
        if (data) {
          this.ticketId = data.toString();
          this.loading = false;
          this.submitted = false;
          this.ticket.Reply = '';

          this.notifyService.showSuccess(
            'Ticket updated successfully',
            'Customer Support Portal'
          );

          this.router.navigate(['/my-tickets']);

          // this.getProblems(this.ticket.ProblemId);

          // this.loadTicketdetails(this.ticketId);

          // this.getImpacts(this.ticket.ProductId,this.ticket.ProblemId);
        }
      },
      (error) => {
        this.error = error;
        this.loading = false;
        this.submitted = false;
        this.loadTicketdetails(this.ticketId);
      }
    );
  }

  AssignToMe() {
    this.ticket.UserId = this.cUser.userId;
    this.ticket.ModifiedBy = this.cUser.userId;
    this.ticket.AssignId = this.cUser.userId;
    this.ticket.UserName = this.cUser.name;
    this.isassigningtome = true;

    this.ticketsService.AssignTicketToMe(this.ticket).subscribe(
      (data) => {
        if (data) {
          this.loading = false;

          this.getProblems(this.ticket.ProblemId);

          this.getImpacts(this.ticket.ProductId, this.ticket.ProblemId);

          this.loadTicketdetails(this.ticketId);

          this.notifyService.showSuccess(
            'Assigned successfully',
            'Customer Support Portal'
          );
        }
      },
      (error) => {
        this.error = error;
        this.loading = false;
        this.isassigningtome = false;

        this.getProblems(this.ticket.ProblemId);

        this.getImpacts(this.ticket.ProductId, this.ticket.ProblemId);

        this.loadTicketdetails(this.ticketId);

        this.notifyService.showSuccess(
          'Assigned successfully',
          'Customer Support Portal'
        );
      }
    );
  }

  onClose() {
    this.location.back();
    // this.router.navigate(['/my-tickets']);
  }

  getAttachedFiles(ticketId: string) {
    this.ticketsService.getAttachedFilesInTickets(ticketId).subscribe(
      (res) => {
        this.attachedFiles = <any[]>res;
      },
      (error) => {
        this.error = error;
        this.loading = false;
      }
    );
  }

  DownloadFile(fileName) {
    if (fileName) {
      this.uploadService.downloadFile(fileName).subscribe(
        (res) => {
          // importedSaveAs(res);
          saveAs(res, fileName);
        },
        (error) => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  }
}
